import { Button } from '../ui/button';
import { NoChat } from '@/assets/svgAsComponents/no-chat';
import { NoChatDark } from '@/assets/svgAsComponents/no-chat-dark';
import { useContext } from 'react';
import { ThemeContext } from '@/context/theme-context';
import { SquaredBackground } from '../squared-background';
import { SmallCompanyLogo } from '@/assets/svgAsComponents/small-company-logo';
import { LandingLanguageSelector } from '../landing/language-selector';
import { LandingThemeSelector } from '../landing/theme-selector';
import { LogoutButton } from '../auth/logout-button';
import { useTranslation } from 'react-i18next';

export const NoConversationSetupYet = () => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);

  return (
    <main>
      <div className="py-5 px-12 border-b flex items-center justify-between bg-background">
        <div className="flex justify-between items-center w-full">
          <div className="flex items-center space-x-2">
            <div className="w-7 h-7">
              <SmallCompanyLogo />
            </div>
            <h1 className="font-bold text-2xl inline-block">
              {t('chat_page.titleWithoutMembers')}
            </h1>
          </div>

          <div className="w-fit inline-flex items-center space-x-5">
            <LandingLanguageSelector />
            <LandingThemeSelector />
            <LogoutButton variant="outline" />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center space-x-2 w-full text-center text-foreground relative isolate bg-background">
        <SquaredBackground />
        <div className="w-1/4 pt-12">{theme == 'dark' ? <NoChatDark /> : <NoChat />}</div>
        <h1 className="text-4xl font-bold">{t('chat_page.noChatSetupYetTitle')}</h1>
        <p className="pt-2 text-lg w-1/3">{t('chat_page.noChatSetupYetDescription')}</p>
        <Button className="mt-4 px-6" onClick={() => window.location.reload()}>
          {t('chat_page.noChatSetupYetRefresh')}
        </Button>
        <p className="pt-4 text-secondary">{t('chat_page.noChatSetupYetCallToAction')}</p>
      </div>
    </main>
  );
};
